import React from 'react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {isPreviewing, isEditing} from '@builder.io/sdk-react'
import {PreviewContainer} from './previewContainer'
import {
    commonRoleBasedContentInputs,
    commonRoleBasedContentPropTypes,
    getDefaultChildren
} from './utils'

const accessType = 'Guest'

export const GuestContent = ({children, hideInEdit}) => {
    const {data: customer, isError: isCustomerError, error: customerError} = useCurrentCustomer()

    const isGuest = customer.isGuest && !customer.isRegistered
    const isPreview = isPreviewing()
    const isEdit = isEditing()

    if (isCustomerError && isPreview) {
        throw new Error('There was an issue fetching customer data: ', customerError)
    }

    if (isCustomerError) {
        console.error('There was an issue fetching customer data: ', customerError)
        return null
    }

    const renderGuestOnlyContent = () => {
        if ((!isGuest && !isEdit) || (isEdit && hideInEdit)) {
            return null
        }
        if (isEdit) {
            return (
                <PreviewContainer type={accessType} data-testid="guestContent-PreviewContainer">
                    {children}
                </PreviewContainer>
            )
        }
        return children
    }

    return renderGuestOnlyContent()
}
GuestContent.propTypes = {
    ...commonRoleBasedContentPropTypes
}
export const GuestContentDefinition = {
    component: GuestContent,
    name: 'GuestContent',
    canHaveChildren: true,
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/user.svg',
    noWrap: true,
    defaultChildren: getDefaultChildren(accessType),
    inputs: [...commonRoleBasedContentInputs]
}
